import { Module } from 'vuex-simple';

import systemLayoutModule from '@/HostApp/services/SystemLayout/SystemLayoutModule';
import cssBundlerModule from '@/HostApp/services/CSSBundler/CSSBundlerModule';
import spriteBundlerModule from '@/HostApp/services/CSSBundler/SpriteBundlerModule';
import sharedContext from '@/HostApp/store/SharedContext/sharedContext';
import analyticsModule from '@/HostApp/services/Analytics/AnalyticsModule';
import designTokensModule from '@/HostApp/services/DesignTokens/DesignTokensModule';
import fontLoaderModule from '@/HostApp/services/FontLoader/FontLoaderModule';
import alertServiceModule from '@/HostApp/services/AlertService/AlertServiceModule';
import helpCenterServiceModule from '@/HostApp/services/HelpCenterService/HelpCenterServiceModule';
import httpServiceModule from '@/HostApp/services/HttpService/HttpServiceModule';
import i18nServiceModule from '@/HostApp/services/I18nService/I18nServiceModule';

export class HostServices {
	@Module()
	public systemLayoutModule = systemLayoutModule;

	@Module()
	public cssBundlerModule = cssBundlerModule;

	@Module()
	public spriteBundlerModule = spriteBundlerModule;

	@Module()
	public sharedContext = sharedContext;

	@Module()
	public AnalyticsModule = analyticsModule;

	@Module()
	public designTokensModule = designTokensModule;

	@Module()
	public fontLoaderModule = fontLoaderModule;

	@Module()
	public alertServiceModule = alertServiceModule;

	@Module()
	public helpCenterServiceModule = helpCenterServiceModule;

	@Module()
	public i18nServiceModule = i18nServiceModule;

	@Module()
	public httpServiceModule = httpServiceModule;
}

const hostServices = new HostServices();

export default hostServices;
